// extracted by mini-css-extract-plugin
export default {"container":"X60rAl","responsive":"C7NNVG","empty":"ocbIzD","emptyContent":"b2Fjfy","navButtonOutside":"jnPU7F","videoDescription":"QVIENZ"};